module.exports = __webpack_public_path__ + "img/copy2.ea3ffe65.svg";